angular.module('EMR.Admin') 
    .directive('emrDebouncedClick', ['$timeout', function ($timeout) { 
        return { 
            restrict: 'A', 
            scope: { 
                clickHandler: '&emrDebouncedClick', 
                emrDelay: '@emrDebounce' 
            }, 
            link: function (scope, element) { 
                let timeout; 
                element.bind('click', function () { 
                    $timeout.cancel(timeout); 
                    timeout = $timeout(function () { 
                        scope.clickHandler.apply(this, arguments); 
                    }, scope.emrDelay || 50); 
                }); 
            } 
        } 
    }]);